
import { BasicDialogHandler } from "@goodgamestudios/core";
import { int } from "@goodgamestudios/math-utilities";
import { SFConstants } from "../../../constants/SFConstants";
import { ErrorCodes } from "../../../constants/shared/ErrorCodes";
import { Poker2BrokeDialog } from "../../../view/dialogs/Poker2BrokeDialog";
import { Poker2BrokeDialogProperties } from "../../../view/dialogs/Poker2BrokeDialogProperties";
import { Poker2Command } from "../Poker2Command";

export class BRPCommand extends Poker2Command {
    protected get cmdId(): string {
        return "brp";
    }

    public executeCommand(error: number, params: any[]): boolean {
        if (error == 0) {
            var paramObj: any = JSON.parse(params[1]);
            var chips: number = paramObj.chips;
            var count: number = int(paramObj.count);
            BasicDialogHandler.getInstance().registerDialogs("Poker2BrokeDialog", new Poker2BrokeDialogProperties(chips, count), true, BasicDialogHandler.PRIORITY_TOP);
        }
        return (error == 0);
    }

    /**
    * TRANSPILER GENERATED FUNCTION: If a overriding getter is defined, the setter must be defined as well. WARNING: the defining class was not found, so the parentclass was assumed. Please check if this call is correct.
    **/
    protected set cmdId(value/*:String*/)/*:void*/ {
        Object.getOwnPropertyDescriptor(Poker2Command.prototype, "cmdId").set.call(this, value);
    }
}
